import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherAlert, UpdateWeatherAlertDto } from 'types';

export const updateWeatherAlert = ({
  data,
  alertId,
}: {
  data: UpdateWeatherAlertDto;
  alertId: number;
}): Promise<WeatherAlert> => {
  return axios.put(`/api/weather/alerts/${alertId}`, data);
};

type UseUpdateWeatherAlertOptions = {
  config?: MutationConfig<typeof updateWeatherAlert>;
};

export const useUpdateWeatherAlert = ({
  config,
}: UseUpdateWeatherAlertOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherAlerts) {
        queryClient.setQueryData(
          ['weatherAlerts'],
          context.previousWeatherAlerts
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherAlerts']);
      queryClient.invalidateQueries(['dishes']);
    },
    ...config,
    mutationFn: updateWeatherAlert,
  });
};
